import React from "react";
import Icon from "./Icon";
import tiolLogo from "../../assets/img/tiolLogo.png"; // <- put the TIOL logo here (path is yours to adjust)

const TRUST = [
  "Every answer linked to its citation",
  "Notifications & circulars tracked",
  "DPDP Act–compliant",
];

const SIDEBAR = [
  "Litigations",
  "Smart Search",
  "My Documents",
  "Alerts",
  "Search History",
  "Draft Studio",
];
const TABS = ["Research Brief", "Case Law", "Notifications", "Regulatory"];
const CITES = [
  {
    id: "2019-TIOL-2621-CESTAT-AHM",
    title: "Palav Synthetics vs CCE & ST",
    meta: "CESTAT · Jun 3, 2019",
  },
  {
    id: "2022-TIOL-360-HC-AHM-GST",
    title: "New Nalbandh Traders vs State of Gujarat",
    meta: "High Court · Feb 23, 2022",
  },
];

const ProductMock = () => (
  <div className="vd-mock">
    <div className="vd-mock__bar">
      <i />
      <i />
      <i />
      <span>app.vedum.ai / research</span>
    </div>
    <div className="vd-mock__body">
      <div className="vd-mock__side">
        {SIDEBAR.map((s) => (
          <span key={s} className={s === "Smart Search" ? "is-active" : ""}>
            {s}
          </span>
        ))}
      </div>
      <div className="vd-mock__main">
        <div className="d-flex justify-content-between">
          <strong>Research</strong>
          <span className="vd-badge">Active</span>
        </div>
        <div className="vd-mock__q">
          <span className="vd-mock__avatar">VD</span>
          <div>
            What measures prevent involvement in transactions with phantom or
            ghost taxpayers?
          </div>
        </div>
        <div className="vd-tabs">
          {TABS.map((t, i) => (
            <span key={t} className={i === 0 ? "is-active" : ""}>
              {t}
            </span>
          ))}
        </div>
        <div>
          Recipients must verify the supplier’s identity and address and take
          reasonable steps before claiming credit; credit may be denied where
          issuing firms are found non-existent.
          <div>
            <span className="vd-cite">2019-TIOL-2621-CESTAT-AHM</span>
          </div>
        </div>
        <div className="mt-3">
          <span className="vd-eyebrow">CITATIONS · 10</span>
          {CITES.map((c) => (
            <div className="vd-cite-card" key={c.id}>
              <b>{c.id}</b>
              <div>{c.title}</div>
              <small className="text-muted">{c.meta}</small>
            </div>
          ))}
        </div>
        <div className="vd-mock__foot">
          <span>
            <strong>8</strong> sources selected
          </span>
          <em>Start a draft</em>
        </div>
      </div>
    </div>
  </div>
);

const Hero = () => (
  <section id="top" className="vd-hero">
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-6">
          <span className="vd-pill">
            <i /> Legal AI built for Indian practice
          </span>
          <h1 className="vd-hero__title">
            From show-cause notice to final hearing — researched, drafted and
            tracked in one place.
          </h1>
          <p className="vd-hero__lead">
            Vedum gives advocates, law firms, tax practitioners and in-house
            teams AI-powered research across Indian case law and notifications,
            litigation tracking with relevance-based alerts, and cited drafting
            — so you respond to courts and authorities faster, with authority
            you can stand behind.
          </p>
          <div className="d-flex flex-wrap gap-3">
            <a href="#contact" className="vd-btn vd-btn--primary">
              Book a demo <Icon name="arrow" size={16} />
            </a>
            <a href="#insights" className="vd-btn vd-btn--ghost">
              See Legal Insights
            </a>
          </div>
          <div className="vd-checks">
            {TRUST.map((t) => (
              <span key={t}>
                <Icon name="check" color="#1E3270" /> {t}
              </span>
            ))}
          </div>
          <a href="#partner" className="vd-partner-chip">
            <img src={tiolLogo} alt="TIOL" />
            <span>
              <small>CASE LAW PARTNER</small>
              <span>Curated case law from taxindiaonline.com</span>
            </span>
          </a>
        </div>
        <div className="col-lg-6">
          <ProductMock />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
